import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './lang/en';
import ja from './lang/ja';
import zh from './lang/zh';
import zt from './lang/zt';
import ko from './lang/ko';
export const DEFAULT_LOCALE = 'zh';
export const LOCALE_LIST = ['en', 'ja', 'ko', 'zh', 'zt'];

export const LOCALE_MAP: Record<string, string> = {
  en_US: 'en',
  ja_JP: 'ja',
  zh_CN: 'zh',
  zh_TW: 'zt',
  ko_KR: 'ko'
};
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  zh: {
    translation: {
      ...zh
    }
  },
  ja: {
    translation: {
      ...ja
    }
  },
  en: {
    translation: {
      ...en
    }
  },
  ko: {
    translation: {
      ...ko
    }
  },
  zt: {
    translation: {
      ...zt
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  returnNull: false,
  resources
});

export function setLocale(locale: string): string {
  void i18n.changeLanguage(locale);
  document.documentElement.setAttribute('lang', locale);
  localStorage.setItem('locale', locale);
  return locale;
}

function getLocaleParams() {
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get('lang') || '';
  if (LOCALE_LIST.includes(lang)) {
    return lang;
  }

  if (Object.keys(LOCALE_MAP).includes(lang)) {
    return LOCALE_MAP[lang];
  }
}

(() => {
  const defaultLocale =
    getLocaleParams() || localStorage.getItem('locale') || DEFAULT_LOCALE;
  setLocale(defaultLocale);
})();

export default i18n;
